import { TranslateService } from './../../shared/translate/translate.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from "../../shared/models/auth.service";

@Component({
  selector: 'wego-orgadmin',
  template: `
  <div class="admin-role">
    <div [class]="toggleClass" (window:resize)="onResize($event)" >
      <wego-navbar (toggleMenu)="ToggleMenuLocal()"></wego-navbar>
      <wego-sidebar [menu]="menu"></wego-sidebar>
      <wego-content-wrapper></wego-content-wrapper>
      <wego-footer></wego-footer>
    </div>
  </div>
  `,
})

export class OrgAdminComponent implements OnInit, OnDestroy {
  toggleClass: string = "ui-skins sidebar-mini";
  menu: any = [
    {
      title: 'LblDashboard',
      icon: 'fa fa-tachometer fa-fw',
      redirectPath: 'dashboard',
    }, {
      title: 'LblOrganization',
      icon: 'fa fa-sitemap fa-fw',
      redirectPath: 'organization/list',
    }, {
      title: 'LblPersons',
      icon: 'fa fa-user fa-fw',
      redirectPath: 'person/list',
      items: [{
        title: 'LblPersonOverview',
        icon: '',
        redirectPath: 'person/list',
      }]
    },
    {
      title: 'LblSharedVehicleGroups',
      icon: 'fa fa-group fa-fw',
      redirectPath: 'sharedvehiclegroup/list',
      items: [{
        title: 'LblSharedVehicleGroupOverview',
        icon: '',
        redirectPath: 'sharedvehiclegroup/list',
      }]
    },
    {
      title: 'LblDrivers',
      icon: 'fa fa-male fa-fw',
      redirectPath: 'driver/list',
    },
    {
      title: 'LblBookings',
      icon: 'fa fa-calendar fa-fw',
      redirectPath: 'booking',
      items: [
        {
          title: 'LblBookingsOverview',
          icon: '',
          redirectPath: 'booking/overview',
        },
        {
          title: 'LblNormal',
          icon: '',
          redirectPath: 'booking',
        }
      ]
    },
    {
      title: 'LblInvoicing',
      icon: 'fa fa-file-text fa-fw',
      redirectPath: 'invoice',
      items: [{
        title: 'LblInvoices',
        icon: '',
        redirectPath: 'invoice/list',
      }]
    }
  ];

  constructor(private translate: TranslateService,
    private authService: AuthService) { }
  ngOnInit() {
    this.translate.setDetectedLang();
  }

  public ToggleMenuLocal() {
    if (window.innerWidth > 767) {
      if (this.toggleClass == "ui-skins sidebar-mini")
        this.toggleClass = "ui-skins sidebar-mini sidebar-collapse";
      else if (this.toggleClass == "ui-skins sidebar-mini sidebar-collapse" || this.toggleClass == "ui-skins sidebar-mini sidebar-open")
        this.toggleClass = "ui-skins sidebar-mini";
    }
    else {
      if (this.toggleClass == "ui-skins sidebar-mini")
        this.toggleClass = "ui-skins sidebar-mini sidebar-open";
      else if (this.toggleClass == "ui-skins sidebar-mini sidebar-open" || this.toggleClass == "ui-skins sidebar-mini sidebar-collapse")
        this.toggleClass = "ui-skins sidebar-mini";
    }
  }

  onResize(event: any) {
  }

  ngOnDestroy() { }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/role/components/orgadmin.component.ts